import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, useField } from 'formik';
import * as Yup from 'yup';
import PricesTableTitle from '../../layout/PageWelcomeBgTitle-component';
import StartDatePicker, { EndDatePicker } from './TableDatePicker-component';
import emailjs from 'emailjs-com';

const SuccesPopUp = () => {
  return (
    <>
      <div id="succes-PopUp" className="modal">
        <div className="succes-PopUp">
          <p>Thank you for your Request! Our managers will contact you as soon as possible!</p>
          <span className="cta-btn cta-btn--popup close">Great</span>
        </div>
      </div>
    </>
  );
};
const TryAgainPopUp = () => {
  return (
    <>
      <div id="error-popup'" className="modal">
        <div className="succes-PopUp">
          <p>Sorry Your request could not be send. Try again later.</p>
          <span className="cta-btn cta-btn--popup close">Okay</span>
        </div>
      </div>
    </>
  );
};

const TextInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input className="text-input" {...field} {...props} />
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </>
  );
};
const MessageInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <textarea className="message-input" {...field} {...props} />
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </>
  );
};

const PhoneNumberInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input className="text-input" {...field} {...props} />
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </>
  );
};

const TreatmentSelect = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <>
      <label htmlFor={props.id || props.name}>{label}</label>
      <select {...field} {...props}></select>
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </>
  );
};
const MyCheckbox = ({ children, ...props }) => {
  const [field, meta] = useField({ ...props, type: 'checkbox' });
  return (
    <>
      <label htmlFor={props.id || props.name} className="checkbox">
        <input {...field} {...props} type="checkbox" />
        {children}
      </label>
      {meta.touched && meta.error ? <div className="error">{meta.error}</div> : null}
    </>
  );
};

const phoneRegEx = /[1-9][0-9 \-\(\)\.]{7,}$/;

const buildValidationSchema = ({ showLocation, showTreatment, showEndDate }) =>
  Yup.object({
    clientsName: Yup.string().max(35, 'Must be 35 characters or less').required('Required'),
    email: Yup.string().email('Invalid email addresss`').required('Required'),
    phoneNumber: Yup.string()
      .matches(phoneRegEx, 'Phone number is not valid')
      .required('Required'),
    ...(showLocation && {
      location: Yup.string().max(35, 'Must be 35 characters or less').required('Required'),
    }),
    date: Yup.date().required('Required'),
    ...(showTreatment && {
      treatment: Yup.string().required('Required'),
    }),
    ...(showEndDate && {
      endDate: Yup.date().required('Required'),
    }),
    acceptedTerms: Yup.boolean()
      .required('Required')
      .oneOf([true], 'You must accept the terms and conditions.'),
  });

export const SignupForm = ({
  treatments,
  showLocation = true,
  showTreatment = true,
  showEndDate = false,
  defaultTreatment = '',
}) => {
  const initialValues = {
    clientsName: '',
    email: '',
    phoneNumber: '',
    ...(showLocation && { location: '' }),
    date: new Date(),
    ...(showEndDate && { endDate: new Date() }),
    ...(showTreatment && { treatment: '' }),
    message: '',
    acceptedTerms: false,
  };
  const resetValues = {
    clientsName: '',
    email: '',
    phoneNumber: '',
    ...(showLocation && { location: '' }),
    date: new Date(),
    ...(showEndDate && { endDate: new Date() }),
    ...(showTreatment && { treatment: '' }),
    message: '',
    acceptedTerms: false,
  };
  return (
    <>
      <div id="request-form"></div>
      <PricesTableTitle className="form-section-title" title="Send your request" />
      <h6>*All bookings require confirmation.</h6>
      <Formik
        initialValues={initialValues}
        isSubmitting={true}
        validationSchema={buildValidationSchema({ showLocation, showTreatment, showEndDate })}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            var btn = document.getElementById('submit');
            var modal = document.getElementById('succes-PopUp');

            btn.onclick = function () {
              modal.style.display = 'block';
            };

            var closeBtn = document.getElementsByClassName('close')[0];
            modal.style.display = 'block';

            closeBtn.onclick = function () {
              console.log('clicked');
              modal.style.display = 'none';
            };
            window.onclick = function (event) {
              modal.style.display = 'none';
            };
            const endDateStr =
              showEndDate && values.endDate
                ? new Date(values.endDate).toLocaleString()
                : '';
            const emailPayload = {
              clientsName: values.clientsName,
              email: values.email,
              phoneNumber: values.phoneNumber,
              ...(showLocation && { location: values.location }),
              date: values.date ? new Date(values.date).toLocaleString() : '',
              treatment: showTreatment ? values.treatment : defaultTreatment,
              message: showEndDate
                ? `End Date: ${endDateStr}\n\n${values.message}`
                : values.message,
            };
            emailjs
              .send('ahsmb-gmail', 'template_fhul34e', emailPayload, 'user_sYM3nz1Wl6wCbCvu7XXBg')
              .then(
                (result) => {
                  console.log(result.text);
                },
                (error) => {
                  console.log(error.text);
                  var modal = document.getElementById('error-popup');

                  var span = document.getElementsByClassName('close')[0];
                  modal.style.display = 'block';

                  span.onclick = function () {
                    modal.style.display = 'none';
                  };
                  window.onclick = function (event) {
                    modal.style.display = 'none';
                  };
                }
              );
            actions.setSubmitting(false);
            actions.resetForm({ values: resetValues });
          }, 500);
        }}
      >
        <Form className="main-form">
          <TextInput label="Clients Name" name="clientsName" type="text" placeholder="" />
          <TextInput label="Email Address" name="email" type="email" placeholder="" />
          <PhoneNumberInput label="Phone Number" name="phoneNumber" type="tel" placeholder="" />
          {showLocation && (
            <PhoneNumberInput
              label="Location"
              name="location"
              type="text"
              placeholder="Enter your Location/Area"
            />
          )}
          <StartDatePicker name="date" />
          {showEndDate && <EndDatePicker name="endDate" />}
          {showTreatment && treatments && (
            <TreatmentSelect label="Choose treatment" name="treatment">
              <option value="">---</option>
              {treatments.map((treatment) => {
                const { title, price60, price90 } = treatment;
                return (
                  <option key={title} value={title}>
                    {title}
                    {' - '}
                    {price60 || price90} {'Euro'}
                  </option>
                );
              })}
            </TreatmentSelect>
          )}
          <MessageInput label="Message Input" name="message" type="text" placeholder="" />
          <MyCheckbox name="acceptedTerms">I accept the terms and conditions</MyCheckbox>

          <button id="submit" type="submit">
            Submit
          </button>
        </Form>
      </Formik>
      <TryAgainPopUp />
      <SuccesPopUp />
    </>
  );
};

TextInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};
MessageInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};
PhoneNumberInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};
MyCheckbox.propTypes = {
  children: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};
TreatmentSelect.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};
SignupForm.propTypes = {
  treatments: PropTypes.array,
  showLocation: PropTypes.bool,
  showTreatment: PropTypes.bool,
  showEndDate: PropTypes.bool,
  defaultTreatment: PropTypes.string,
};
